import { render, staticRenderFns } from "./EmailSuccess-Desktop.vue?vue&type=template&id=9209a90a&scoped=true"
import script from "./EmailSuccess-Desktop.vue?vue&type=script&lang=js"
export * from "./EmailSuccess-Desktop.vue?vue&type=script&lang=js"
import style0 from "./EmailSuccess-Desktop.vue?vue&type=style&index=0&id=9209a90a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9209a90a",
  null
  
)

export default component.exports